export const FIRM_DOCUMENT_COMPANIES_QUERY_KEY = 'firm-document-companies';
export const FIRM_DOCUMENT_COMPANIES_QUERY_STALE_TIME_MS = 30_000;
